export default __webpack_public_path__ + "static/media/filterIcon.724d81a5.svg";